import { render, staticRenderFns } from "./FacilityDashboard.vue?vue&type=template&id=894b5b22&scoped=true&"
import script from "./FacilityDashboard.vue?vue&type=script&lang=js&"
export * from "./FacilityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FacilityDashboard.vue?vue&type=style&index=0&id=894b5b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894b5b22",
  null
  
)

export default component.exports